import React from 'react';
import { connect, useSelector } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { IState } from '../../config/rootReducer';
import ErrorPage from '../../shared/components/ErrorPage/ErrorPage';
import { DispatchAccess } from './action/HomeAccessActions';

export interface IErrorProp {
  readonly reload: () => void;
}

/* Este componente extiende del componente general ErrorPage. Recibe una función reload
que es usada para cargar los datos de nuevo al momento que falle una carga. */
const ErrorHistoryUserInfo = ({ reload }: IErrorProp) => {
  const reloadFunction = () => reload();
  const code = useSelector((state: IState) => state.home.errorCode);

  return <ErrorPage functionToReload={reloadFunction} code={code} />;
};

/* MapDispatchToProps que asigna a la variable reload una función que busca los datos al
servicio wm-metadata */
const mapDispatchToProps = (dispatch: ThunkDispatch<IState, void, AnyAction>) => {
  return {
    reload: () => dispatch(DispatchAccess(false)),
  };
};

export default connect(
  null,
  mapDispatchToProps
)(ErrorHistoryUserInfo);
